// utils
import {
  getAvailableRosterPlanModes,
  getInitialRosterPlanMode
} from './getAvailableRosterPlanModes';

// types
import type {
  RosterPlanModeGrants,
  RosterPlanSwitchableMode
} from '../RosterPlan.types';

/**
 * The mode the screen is in: the one the planner picked, as long as the grants allow it, otherwise
 * the opening mode (plan for a planner who may plan, view otherwise — Dojo's `valueProp`).
 *
 * Derived rather than written to the store on mount, so it cannot go stale: grants that arrive
 * after the first render, or that lose a mode, move the screen along instead of leaving it in a mode
 * the switch no longer offers.
 */
export const resolveRosterPlanMode = (
  pickedMode: RosterPlanSwitchableMode | null,
  grants: RosterPlanModeGrants
): RosterPlanSwitchableMode =>
  pickedMode && getAvailableRosterPlanModes(grants).includes(pickedMode)
    ? pickedMode
    : getInitialRosterPlanMode(grants);
